import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { isDebuggerErrorCode } from "~/modules/error/ErrorCode/ErrorCodeHelper";
import { FlexSdkError } from "~/modules/error/FlexSdkError/FlexSdkError";
import { getLogger, LoggerName } from "~/modules/logger";
import { AnalyticsImpl } from "~/modules/telemetry/AnalyticsImpl";
import { sanitizeMessage, sanitizeStack } from "~/modules/telemetry/sanitize";
import { sendLifecycleTrackingEvent, toCauseMessage } from "~/modules/telemetry/utils";
import { EVENTS } from "~/modules/telemetry/Analytics";
import { SessionImpl } from "~/modules/session/Session/SessionImpl";





export function reportError(ctx: ContextManager) {
    return (error: FlexSdkError) => {
        try {
            const analytics = ctx.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);
            const session = ctx.retrieveInstanceOf(ContextInstance.SessionImpl, SessionImpl);

            const causeMessage = toCauseMessage(error.cause);
            const debuggerFlag = isDebuggerErrorCode(error.code);

            sendLifecycleTrackingEvent(EVENTS.ErrorReported, analytics, session.accountSid, {
                code: error.code,
                debugger: debuggerFlag,
                message: sanitizeMessage(error.message),
                module: error.metadata.module,
                reporter: "flex-sdk",
                resourceSid: error.metadata.resourceSid,
                severity: error.metadata.severity,
                source: error.metadata.source ?? "flex-sdk",
                stackTrace: sanitizeStack(error.stack, error.message),
                unhandled: error.metadata.unhandled,
                cause: causeMessage === undefined ? undefined : sanitizeMessage(causeMessage)
            });
        } catch (e) {
            const logger = getLogger(ctx)(LoggerName.Error);
            logger.debug("Failed to report the error", e);
        }
    };
}
